import { render, staticRenderFns } from "./SFTPCsRes.vue?vue&type=template&id=6ffe84e8&scoped=true&"
import script from "./SFTPCsRes.vue?vue&type=script&lang=js&"
export * from "./SFTPCsRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe84e8",
  null
  
)

export default component.exports